import { render } from "./Calculate.vue?vue&type=template&id=677bcca0&scoped=true"
import script from "./Calculate.vue?vue&type=script&lang=js"
export * from "./Calculate.vue?vue&type=script&lang=js"

import "./Calculate.vue?vue&type=style&index=0&id=677bcca0&lang=scss&scoped=true"

import exportComponent from "D:\\a\\Web-Widgets-FinanceJyskeFinans\\Web-Widgets-FinanceJyskeFinans\\FinanceJyskeFinans.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677bcca0"]])

export default __exports__